<template>
  <div class="model-info" :class="{ open }">
    <span class="title">{{ i18n('general', 'about') | firstCharUpper }}<!--<font-awesome-icon icon="angle-down" class="icon"/>--></span>
    <div class="text" :class="{ open }" v-html="i18n('general', 'modelInfo')">
    </div>
    <span v-if="!open" @click="open=true" class="open-button">Open</span>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import format from '@/utils/format.js'

/* eslint-disable arena/no-hardcode-param-types */
export default {
  name: 'ModelInfo',
  data () {
    return {
      open: false
    }
  },
  filters: {
    formatTitle: format.formatTitle,
    firstCharUpper: format.firstCharUpper
  },
  computed: {
    ...mapGetters(['i18n'])
  }
}
</script>
<style>
div.model-info {
  background: #eee;
  margin: 30px;
  padding: 30px 30px 10px 30px;
  width: calc(100% - 120px);
  max-height: 400px;
  overflow-y: hidden;
}
div.model-info.open {
  max-height: unset;
}
div.model-info > span.title {
  font-size: 24px;
  display: block;
  margin-bottom: 20px;
  cursor: pointer;
}
div.model-info > span.title > .icon {
  margin-left: 10px;
}
div.model-info > div.text {
  font-size: 18px;
  text-align: justify;
  background: linear-gradient(black, transparent);
  background-clip: text;
  color: transparent;
  max-height: 300px;
}
div.model-info > div.text.open {
  max-height: unset;
  color: unset;
}
div.model-info > div.text > p {
  text-align: justify;
}
div.model-info > div.text a {
  color: #4378bf;
}
div.model-info > span.open-button {
  cursor: pointer;
  font-size: 20px;
  color: #4378bf;
  text-decoration: none;
  display: block;
  text-align: center;
}
@media (max-width: 1200px) {
  div.model-info > div.text {
    font-size: 20px;
  }
}
</style>
